import { reactive } from 'vue';

const state = reactive({
  emAndamento: false,
  bloquearAlternarTela: false,
});

export default {
  state,
  set({ emAndamento = false, bloquearAlternarTela = false } = {}) {
    state.emAndamento = emAndamento;
    state.bloquearAlternarTela = bloquearAlternarTela;
  },
  reset() {
    state.emAndamento = false;
    state.bloquearAlternarTela = false;
  },
  esconderLinkWhatsapp() {
    return state.emAndamento && state.bloquearAlternarTela;
  },
};
